import { useTranslation } from "react-i18next";
import { SectionLabel, CornerCard, StatusPip } from "./primitives";

/**
 * [08] Pricing. Single contact-sales card. Pricing is set per
 * deployment — hectares, seats, retention, support requirements all
 * shift the number, so we don't publish a list.
 */
export function Pricing() {
  const { t } = useTranslation();
  return (
    <section id="pricing" className="relative border-b border-[color:var(--color-app-edge)]">
      <div className="absolute inset-0 bg-topo opacity-50 pointer-events-none" />
      <div className="relative mx-auto max-w-[1320px] px-6 lg:px-10 py-24 md:py-28">
        <SectionLabel
          index={t("pricing.section.index")}
          title={t("pricing.section.title")}
          kicker={t("pricing.section.kicker")}
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-14">
          <h2 className="text-display text-5xl md:text-6xl">
            {t("pricing.headline.before")}{" "}
            <span className="text-accent text-accent-coral">
              {t("pricing.headline.accent")}
            </span>
            {t("pricing.headline.after")}
          </h2>
          <div className="md:pl-8 md:border-l md:border-[color:var(--color-app-edge)] text-[color:var(--color-app-text)]/75 leading-relaxed flex items-center">
            <p>{t("pricing.intro")}</p>
          </div>
        </div>

        <div className="max-w-2xl mx-auto">
          <CornerCard highlighted className="p-10 md:p-14 text-center">
            <div className="flex justify-center mb-6">
              <StatusPip color="amber" pulse>{t("pricing.card.pip")}</StatusPip>
            </div>

            <div className="text-display text-5xl md:text-6xl mb-5">
              {t("pricing.card.headline")}
            </div>

            <p className="text-[color:var(--color-app-text)]/75 max-w-md mx-auto mb-10 leading-relaxed">
              {t("pricing.card.body")}
            </p>

            <a
              href="mailto:sales@ultrascan.ai?subject=UltraScan%20pricing%20enquiry"
              className="inline-flex items-center gap-2 px-6 py-3.5 text-sm font-medium bg-[color:var(--color-forest)] text-[color:var(--color-paper)] dark:bg-[color:var(--color-meadow)] dark:text-[color:var(--color-ink)] hover:opacity-90 transition-opacity"
            >
              {t("pricing.card.cta")}
              <span aria-hidden>→</span>
            </a>

            <div className="mt-8 pt-6 border-t border-[color:var(--color-app-edge)] coord-mono opacity-70">
              {t("pricing.card.fineprint")}
            </div>
          </CornerCard>
        </div>
      </div>
    </section>
  );
}
